<template>
  <div class="new-reg-container">
    <div class="form-section">
      <div class="section-header">
        <div class="section-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="8.5" cy="7" r="4"/>
            <line x1="20" y1="8" x2="20" y2="14"/>
            <line x1="23" y1="11" x2="17" y2="11"/>
          </svg>
        </div>
        <h2>Táncos regisztrálása</h2>
        <p>Küldjön regisztrációs linket egy email címre</p>
      </div>
      
      <div class="form-content">
        <form @submit.prevent="submitEmail(false)" class="modern-form">
          <div class="form-group">
            <label for="email_dancer" class="form-label">Email cím</label>
            <input 
              type="email" 
              id="email_dancer" 
              class="modern-input" 
              v-model="emailDancer" 
              required 
              placeholder="example@email.com"
            />
          </div>
          
          <div class="form-actions">
            <button type="submit" class="btn-primary" :disabled="loadingDancer">
              <svg v-if="loadingDancer" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinning">
                <path d="M21 12a9 9 0 11-6.219-8.56"/>
              </svg>
              <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              {{ loadingDancer ? "Küldés..." : "Küldés" }}
            </button>
          </div>
          
          <div v-if="messageDancer" class="status-message" :class="{'success': successDancer, 'error': !successDancer}">
            <svg v-if="successDancer" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22,4 12,14.01 9,11.01"/>
            </svg>
            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
            {{ messageDancer }}
          </div>
        </form>
      </div>
    </div>
    <br>

    <!-- Teacher Registration Section - Only for admins -->
    <div v-if="isAdmin" class="form-section">
      <div class="section-header">
        <div class="section-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="8.5" cy="7" r="4"/>
            <line x1="20" y1="8" x2="20" y2="14"/>
            <line x1="23" y1="11" x2="17" y2="11"/>
          </svg>
        </div>
        <h2>Tanár regisztrálása</h2>
        <p>Küldjön regisztrációs linket egy email címre</p>
      </div>
      
      <div class="form-content">
        <form @submit.prevent="submitEmail(true)" class="modern-form">
          <div class="form-group">
            <label for="email_teacher" class="form-label">Email cím</label>
            <input 
              type="email" 
              id="email_teacher" 
              class="modern-input" 
              v-model="emailTeacher" 
              required 
              placeholder="example@email.com"
            />
          </div>
          
          <div class="form-actions">
            <button type="submit" class="btn-primary" :disabled="loadingTeacher">
              <svg v-if="loadingTeacher" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinning">
                <path d="M21 12a9 9 0 11-6.219-8.56"/>
              </svg>
              <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              {{ loadingTeacher ? "Küldés..." : "Küldés" }}
            </button>
          </div>
          
          <div v-if="messageTeacher" class="status-message" :class="{'success': successTeacher, 'error': !successTeacher}">
            <svg v-if="successTeacher" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22,4 12,14.01 9,11.01"/>
            </svg>
            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
            {{ messageTeacher }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import axios from 'axios';

  export default {
    data() {
      return {
        emailDancer: "",
        emailTeacher: "",
        loadingDancer: false,
        loadingTeacher: false,
        messageDancer: "",
        messageTeacher: "",
        successDancer: false,
        successTeacher: false,
        isAdmin: false,
        isTeacher: false
      };
    },
    methods: {
      getIsAdmin() {
        this.isAdmin = this.$isAdmin();
      },
      getIsTeacher() {
        this.isTeacher = this.$isTeacher();
      },
      async submitEmail(isTeacher) {
        if (isTeacher) {
          this.loadingTeacher = true;
          this.messageTeacher = "";
          try {
            const response = await axios.post(`${this.$BACKEND_HOST}/api/newreg`, {
              email: this.emailTeacher.trim(),
              isTeacher: true
            });
            this.messageTeacher = response.data?.message || "Meghívó e-mail sikeresen elküldve!";
            this.successTeacher = true;
            this.emailTeacher = "";
          } catch (error) {
            this.messageTeacher = error.response?.data?.message || "Nem sikerült elküldeni az emailt!";
            this.successTeacher = false;
          } finally {
            this.loadingTeacher = false;
          }
        } else {
          this.loadingDancer = true;
          this.messageDancer = "";
          try {
            const response = await axios.post(`${this.$BACKEND_HOST}/api/newreg`, {
              email: this.emailDancer.trim(),
              isTeacher: false
            });
            this.messageDancer = response.data?.message || "Meghívó e-mail sikeresen elküldve!";
            this.successDancer = true;
            this.emailDancer = "";
          } catch (error) {
            this.messageDancer = error.response?.data?.message || "Nem sikerült elküldeni az emailt!";
            this.successDancer = false;
          } finally {
            this.loadingDancer = false;
          }
        }
      }
    },
    mounted() {
      this.getIsAdmin();
      this.getIsTeacher();
    }
  };
  </script>
  
  <style scoped>
  .new-reg-container {
    padding: 2rem;
    max-width: 500px;
    margin: 0 auto;
  }

  .form-section {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow);
    border: 1px solid var(--color-border);
    overflow: hidden;
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 2rem;
    background: var(--color-background-mute);
    border-bottom: 1px solid var(--color-border);
  }

  .section-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    border-radius: 8px;
    color: white;
    flex-shrink: 0;
  }

  .section-header h2 {
    color: var(--color-heading);
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
  }

  .section-header p {
    color: var(--color-text-muted);
    font-size: 0.95rem;
    margin: 0;
    margin-left: auto;
  }

  .form-content {
    padding: 2rem;
  }

  .modern-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .form-label {
    color: var(--color-heading);
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0;
  }

  .modern-input {
    padding: 0.75rem 1rem;
    border: 2px solid var(--color-border);
    border-radius: 8px;
    background: var(--card-bg);
    color: var(--color-text);
    font-size: 0.95rem;
    transition: all 0.3s ease;
    outline: none;
  }

  .modern-input:focus {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(var(--primary-blue-rgb), 0.1);
  }

  .modern-input:hover {
    border-color: var(--primary-blue);
  }

  .form-actions {
    margin-top: 1rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--color-border);
  }

  .btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    outline: none;
    width: 100%;
    justify-content: center;
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    color: white;
    box-shadow: var(--shadow-sm);
  }

  .btn-primary:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }

  .btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  .spinning {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .status-message {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 500;
    margin-top: 1rem;
    border: 1px solid;
  }

  .status-message.success {
    background: rgba(34, 197, 94, 0.1);
    color: #16a34a;
    border-color: rgba(34, 197, 94, 0.2);
  }

  .status-message.error {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
    border-color: rgba(239, 68, 68, 0.2);
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .new-reg-container {
      padding: 1rem;
    }

    .section-header {
      padding: 1rem 1.5rem;
    }

    .section-header h2 {
      font-size: 1.25rem;
    }

    .form-content {
      padding: 1.5rem;
    }
  }

  @media (max-width: 480px) {
    .new-reg-container {
      padding: 0.75rem;
    }

    .section-header {
      padding: 0.75rem 1rem;
    }

    .section-header h2 {
      font-size: 1.125rem;
    }

    .form-content {
      padding: 1rem;
    }

    .btn-primary {
      padding: 0.625rem 1.25rem;
      font-size: 0.875rem;
    }
  }
  </style>
  